module.exports = __webpack_public_path__ + "img/sideHelp3.9ce23c84.svg";